export {
  hasRole,
  hasFeature,
  hasPermission,
  groupHasPermission,
  getPermissionsFromRoutes,
  concatPermissions,
  hasMatchedValueInArray,
} from './permissions';
